var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconCalendararchive24 = function SvgAIconCalendararchive24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 16.6667H3.33333C2.59695 16.6667 2 16.0697 2 15.3333V4.66666C2 3.93028 2.59695 3.33333 3.33333 3.33333H15.3333C16.0697 3.33333 16.6667 3.93028 16.6667 4.66666V8.66666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.33334H16.6667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.66667V2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 4.66667V2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6663 22C19.6119 22 21.9997 19.6122 21.9997 16.6667C21.9997 13.7212 19.6119 11.3333 16.6663 11.3333C13.7208 11.3333 11.333 13.7212 11.333 16.6667C11.333 19.6122 13.7208 22 16.6663 22Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0243 16.6667H16.667V14.3102",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconCalendararchive24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik04LjY2NjY3IDE2LjY2NjdIMy4zMzMzM0MyLjU5Njk1IDE2LjY2NjcgMiAxNi4wNjk3IDIgMTUuMzMzM1Y0LjY2NjY2QzIgMy45MzAyOCAyLjU5Njk1IDMuMzMzMzMgMy4zMzMzMyAzLjMzMzMzSDE1LjMzMzNDMTYuMDY5NyAzLjMzMzMzIDE2LjY2NjcgMy45MzAyOCAxNi42NjY3IDQuNjY2NjZWOC42NjY2NiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTIgNy4zMzMzNEgxNi42NjY3IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNNiA0LjY2NjY3VjIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0xMi42NjcgNC42NjY2N1YyIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE2LjY2NjMgMjJDMTkuNjExOSAyMiAyMS45OTk3IDE5LjYxMjIgMjEuOTk5NyAxNi42NjY3QzIxLjk5OTcgMTMuNzIxMiAxOS42MTE5IDExLjMzMzMgMTYuNjY2MyAxMS4zMzMzQzEzLjcyMDggMTEuMzMzMyAxMS4zMzMgMTMuNzIxMiAxMS4zMzMgMTYuNjY2N0MxMS4zMzMgMTkuNjEyMiAxMy43MjA4IDIyIDE2LjY2NjMgMjJaIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMTkuMDI0MyAxNi42NjY3SDE2LjY2N1YxNC4zMTAyIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4=";